<div class="row" style="margin: auto; margin-top: 2vh;">
    <div class="col avgMarg">
      <div style="text-align: center; margin: auto;">
        <div style="margin:auto;">
          <section class="section" style="padding-bottom: 0rem" id="about">
            <div class="shell shell--size-3">
              <!-- <div class="section__head" *ngIf="!mobile">
                <h6>Algorithm</h6>

                <h2>Risk Score</h2>
                <h3>{{username}}</h3>
              </div>/.section__head -->
              <div class="section__head">
                <h2>Risk Score - {{username}}</h2>
              </div><!-- /.section__head -->
            </div>
          </section>
          <div id="containerRiskGlobal" class="riskCon" style="text-align: center; margin: auto"></div><p style="font-size: large">Average Risk Score: <b>{{riskText}} / 10</b> &nbsp;<a [routerLink]="['/information/risk']" id="RiskInformation" class="wow fadeInRight" data-wow-delay="0.5s"><i
            class="fa-solid fa-circle-info fa-1x howItWorksiRemainingMob"></i></a></p>
        </div>
      </div>
      
    </div>
  </div>